/**
 * @file src/hooks/useShowSupportButton.ts
 * @exports useShowSupportButton
 * @summary Custom hook to determine if support button should be shown
 * @remarks Combines PostHog feature flag with organization's enableSupport setting.
 *          Returns true if feature flag is enabled AND (enableSupport is true or null).
 */

import { useIsSupportButtonEnabled } from "src/helpers/posthog";
import { useOrganizationQuery } from "src/generated/graphql";
import { vIDStateName } from "src/shame/shame-atoms";
import { useSessionValue } from "src/views/VID/views/hooks/sessionHooks";

export const useShowSupportButton = (): boolean => {
	const vIdWebSupportButton = useIsSupportButtonEnabled();
	const vIDVoucher = useSessionValue(vIDStateName.VidVoucher);
	const orgId = vIDVoucher?.organizationId;

	const { data } = useOrganizationQuery({ organizationId: orgId }, { enabled: !!orgId });
	const org = data?.organization;
	const { enableSupport } = org || {};

	// null is the default value for enableSupport for organizations created before this feature, so we'll default to true
	// enableSupport will be undefined for Remote ID capture users, since they don't have access to the organization data
	return Boolean(vIdWebSupportButton && (enableSupport || enableSupport === null));
};
